import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';
import { GenerationWaterBlock } from '../../report/GenerationImpactProjectionBlocks';

export const SupplyAvailabilitySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.waterAnalysis?.supplyAvailability;
  const hasPromotedScenario = !!report.generationImpactProjection?.waterResource;
  return (
    <SectionShell label={label} hasData={!!text || hasPromotedScenario}>
      <GenerationWaterBlock report={report} />
      {text && (
        <EditorialSubsection theme={theme} label="Supply & Demand Assessment">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
